const black_button = {
    backgroundColor: 'black',     // Arka plan rengi siyah
    color: 'white',              // Yazı rengi beyaz
    fontWeight: 'bold'           // Kalın yazı
  };
  
  export default black_button;
  